import * as angular from 'angular';
import {IController, ILogService, IQService} from "angular";
import * as _ from "lodash";
import {EmploymentType} from "../../../agents/types/employment.type";
import {AgentStatusType} from "../../../agents/types/agentStatus.type";
import {AgentsAlerts} from "../../../agents/services/agents-alerts.service";
import {$accountsFactory} from "../../../account/$accounts.factory";
import {DeliveriesRequestsService} from "../../services/deliveries-requests.service";
import {DeliveriesService} from "../../services/deliveries-service.service";
import {SplitService} from "../../../commons/services/split-service.service";

export class ServicesAssignAgentDialogViewCtrl implements IController {
  serviceIds: any;
  routeIds?: any;
  highPriorityAgentsIds: string[];
  linkedAgentId: string;
  isIgnoreScore: boolean;
  isShowAllToggleVisible: boolean;
  isAssociateMode: boolean;
  onAssign: Function;
  onToggleIsIgnoreScore: Function;

  public assignRelatedChecked: boolean;
  public assignableServices: any;
  public unAssignableServices: any;
  public doForce: boolean;
  public isHideOfDutyAgents: boolean = false;
  public services: any[];
  public employmentType: string;

  private employmentTypes: string[];
  private deliveriesRef: any;
  private queryString: any;
  private profileAccountId: any;
  private selectedAgentStatus: any;
  private assignData: any;
  private filteredAgents: any[];

  public queryTypes: string[];
  public selectedQueryType: string;
  public agentsRef: any;
  public loadLimit: number = 20;
  public infiniteScroll: any;
  public agentStatusType: typeof AgentStatusType = AgentStatusType;
  public agentStatuses: string[];
  public selectedAgentStatuses: string[];
  public agentStatus: string;
  public settings: any;
  public tagsToFilter: any;
  public isSmallScreen: boolean;


  /* @ngInject */
  constructor(private $delivery, private deliveriesRequestsService: DeliveriesRequestsService, private deliveriesService: DeliveriesService, private $accounts: $accountsFactory,
              private agentsAlerts: AgentsAlerts,
              private $log: ILogService,
              private $q: IQService,
              private $mdMedia, private $agents, private $infiniteScroll, private splitService: SplitService) {
  }

  $onInit() {
    this.doForce = !!this.splitService.getSiteInfo().forceAssignByDefault;
    this.deliveriesRef = this.$delivery();
    this.agentsRef = this.$agents();

    this.agentStatuses = Object.values(AgentStatusType);
    this.selectedAgentStatuses = [];
    this.agentStatus = undefined;

    this.employmentTypes = [EmploymentType.Payroll, EmploymentType.Independent];
    this.employmentType = undefined;

    this.assignableServices = [];
    this.unAssignableServices = [];
    this.assignRelatedChecked = true;

    this.queryTypes = ['Location', 'OptimizedRoute', 'AgentRoute'];
    this.selectedQueryType = 'Location';
    this.settings = this.splitService.getSiteServicesAssignAgentSettings();

    if ((this.serviceIds?.length || this.routeIds?.length) && !this.isIgnoreScore) {
      this._setAssignData()
    } else if (this.isIgnoreScore) {
      this._getServicesToAssign(this.serviceIds)
        .then(services => {
          this.agentsRef.$query(this._getQueryPayload(services));
          this.infiniteScroll = this.$infiniteScroll(this.agentsRef, this.loadLimit, {getFullData: true});
        })
    }

    this.isSmallScreen = !this.$mdMedia('gt-md');

  }

  $onChanges(changes) {
    if (changes.serviceIds && !changes.serviceIds.isFirstChange()) {
      if (this.serviceIds && this.serviceIds.length && !this.isIgnoreScore) {
        this._setAssignData()
      }
    }

    if (changes.isIgnoreScore && !changes.isIgnoreScore.isFirstChange()) {
      if (this.serviceIds && this.serviceIds.length && !this.isIgnoreScore) {
        this._setAssignData()
      } else if (this.isIgnoreScore) {
        this._getServicesToAssign(this.serviceIds)
          .then(services => {
            this.agentsRef.$query(this._getQueryPayload(services));
            this.infiniteScroll = this.$infiniteScroll(this.agentsRef, this.loadLimit, {getFullData: true});
          })
      }
    }
  };

  onViewSettingsChange(settings) {
    this.settings = settings;
    this.splitService.setSiteServicesAssignAgentSettings(settings);
  }

  onTagChange(tagNames) {
    this.tagsToFilter = tagNames;
    if (this.isIgnoreScore) {
      this._query();
    } else {
      this.onFilterAgents();
    }
  }

  onQueryStringChange(queryString) {
    this.queryString = queryString;
    if (this.isIgnoreScore) {
      this._query();
    } else {
      this.onFilterAgents(queryString);
    }
  }

  onHideOffDutyAgentsChanged(isHideOfDutyAgents: boolean) {
    this.onFilterAgents(this.queryString);
  }

  onChangeAgentStatus(statuses) {
    this.selectedAgentStatuses = statuses;
    if (this.isIgnoreScore) {
      this._query();
    } else {
      this.onFilterAgents();
    }
  }


  onSelectEmploymentType(type: string) {
    this.employmentType = type;
    if (this.isIgnoreScore) {
      this._query();
    } else {
      this.onFilterAgents();
    }
  }

  onFilterAgents(queryString?) {
    this.filteredAgents = _.filter(this.assignData.list, item => {
      return ((!this.employmentType || item.agent.employmentType === this.employmentType) &&
        (!this.selectedAgentStatuses?.length || _.includes(this.selectedAgentStatuses, item.agent.status)) &&
        (!this.tagsToFilter || this.tagsToFilter.some(t => item.agent.tags?.includes(t))) &&
        (!queryString ||
          item.agent.user.firstName?.toLowerCase().includes(queryString.toLowerCase()) ||
          item.agent.user.lastName?.toLowerCase().includes(queryString.toLowerCase()) ||
          item.agent.user.mobilePhone?.includes(queryString.toLowerCase())));
    });
  }

  onSelectQueryType(value) {
    if (value === this.selectedQueryType) {
      return;
    }

    if (!value) {
      this.selectedQueryType = this.queryTypes[0];
    } else {
      this.selectedQueryType = value;
    }

    this._setAssignData();
  }


  onAssignServicesToggled() {
    this.assignRelatedChecked = !this.assignRelatedChecked;
    this._setAssignData()
  }

  onAssignAgent(agent, form) {
    form.$setSubmitted(true);
    if (form.$valid) {
      const relatedServicesIds = _.map(this.assignableServices, (s) => {
        return s.id
      })

      this.onAssign({
        agent,
        relatedServicesIds: this.assignRelatedChecked ? relatedServicesIds : [],
        doForce: this.doForce
      })
    }
  }


  setEvents() {
    const div1 = document.getElementById('services-assign-agent-dialog-view').querySelectorAll("#services-assign-agent-dialog-view-header")[0];
    const div2 = document.getElementById('services-assign-agent-dialog-view').querySelectorAll('.md-virtual-repeat-scroller')[0];

    div2.addEventListener('scroll', e => {
      div1.scrollTop = div2.scrollTop;
      div1.scrollLeft = div2.scrollLeft;
    }, {passive: true})
  }


  // ******************************
  //        Private methods
  // ******************************

  private _getServicesToAssign(ids: string[]) {
    return this.deliveriesRef.$asyncValues(ids)
      .then((services) => {
        this.services = services;
        const relatedServiceIds = this.deliveriesService.getRelatedServicesByTypeMultiple(services, "SupplyTogether");
        if (relatedServiceIds.length) {
          return this.deliveriesRef.$asyncValues(relatedServiceIds)
        } else {
          return this.$q.when([])
        }
      })
      .then((relatedService) => {
        this.services = _.concat(this.services, relatedService);
        return this.$q.when(this.services)
      })
  }

  private _setAssignData() {

    let group = this._getGroup(),
      status = this._getStatus();

    this.assignData = undefined;
    // this.unpackedDeliveryIds = undefined;

    if (this.routeIds?.length) {
      return this.deliveriesRequestsService.getAssignAgentDataByRoutes(this.routeIds, this.selectedQueryType, this.queryString, group, status)
        .then((data) => {
          this.assignData = data;
          this.filteredAgents = data.list;
          // this._setUnpackedDeliveries(services);
          if (_.isEqual(this.selectedQueryType, 'AgentRoute') && _.get(this.assignData, 'list.length')) {
            this.profileAccountId = _.get(this.assignData, 'list[0].accountIdForConfigProfile');
          }

          this.onFilterAgents();
          this._setPriorityAgentsFirst(this.highPriorityAgentsIds);
        })
        .catch((error) => {
          this.agentsAlerts.getManyError();
          this.$log.error('Failed to get assign data ' +
            '@servicesAssignDialogView@_setAssignData', error);
        })
    } else {
      return this.deliveriesRef.$asyncValues(this.serviceIds)
        .then((services) => {
          this.services = services;
          if (!this.assignRelatedChecked) {
            return [];
          }
          const relatedServiceIds = this.deliveriesService.getRelatedServicesByTypeMultiple(services, "SupplyTogether");
          if (relatedServiceIds.length) {
            return this.deliveriesRef.$asyncValues(relatedServiceIds)
          }

        })
        .then((relatedService) => {
          let totalServices = this.serviceIds;
          if (!relatedService) {
            this.assignRelatedChecked = false;
          }
          if (this.assignRelatedChecked && relatedService) {
            this._setRelations(relatedService);
            const assignableServicesIds = _.map(this.assignableServices, (as: any) => {
              return as.id;
            })

            // for the totals
            this.services = _.concat(this.services, this.assignableServices);
            totalServices = _.union(this.serviceIds, assignableServicesIds);
          }


          return this.deliveriesRequestsService.getAssignAgentData(totalServices, this.selectedQueryType, this.queryString, group, status)
        })
        .then((data) => {
          this.assignData = data;
          this.filteredAgents = data.list;
          // this._setUnpackedDeliveries(services);
          if (_.isEqual(this.selectedQueryType, 'AgentRoute') && _.get(this.assignData, 'list.length')) {
            this.profileAccountId = _.get(this.assignData, 'list[0].accountIdForConfigProfile');
          }

          this.onFilterAgents();
          this._setPriorityAgentsFirst(this.highPriorityAgentsIds);
        })
        .catch((error) => {
          this.agentsAlerts.getManyError();
          this.$log.error('Failed to get assign data ' +
            '@servicesAssignDialogView@_setAssignData', error);
        })
    }
  }

  private _setRelations(relatedServices: any): void {

    const assignableServices = relatedServices.filter((relatedService) => {
      return !(relatedService.status == "Completed" || relatedService.status == "Canceled");
    });
    const unAssignableServices = _.differenceBy(relatedServices, assignableServices);

    // relatedServices entities may be shared, frozen references (e.g. from the NgRx store),
    // so clone them before ng-repeat tries to stamp a $$hashKey onto them.
    this.assignableServices = angular.copy(assignableServices);
    this.unAssignableServices = angular.copy(unAssignableServices);
  }

  private _setPriorityAgentsFirst(highPriorityAgentsIds) {
    if (!_.get(highPriorityAgentsIds, 'length')) return;

    const priorityAgentsList = []
    _.forEach(highPriorityAgentsIds, (pai) => {
      const agent = _.find(this.assignData.list, (agent) => {
        return agent.agentId === pai;
      })
      if (agent) {
        priorityAgentsList.push(agent);
      }
    });

    //remove found priority agents from main list
    _.forEach(priorityAgentsList, (pa) => {
      {
        _.remove(this.assignData.list, (agent: any) => {
          return agent.agentId === pa.agentId;
        })
      }
    })
    this.assignData.list = _.concat(priorityAgentsList, this.assignData.list);

  }

  private _getGroup() {
    return this.selectedAgentStatus === 'Active' ? 'Active' : undefined;
  }

  private _getStatus() {
    return this.selectedAgentStatus === 'OffDuty' ? 'OffDuty' : undefined;
  }

  private _getQueryPayload(services?) {
    // const accountIds = _.map(services, 'accountId');
    // const branchIds = _.flatMap(services, 'branchIds');
    const requiredSkills = services ? _.compact(_.uniq(_.flatMap(services, 'requiredSkills'))) : null;
    return {
      // accountIds: accountIds,
      // branchIds: branchIds,
      group: this.isIgnoreScore ? 'Active' : '',
      active: this.isIgnoreScore,
      skill: requiredSkills,
      query: this.queryString,
      status: this.agentStatus,
      type: this.employmentType,
      limit: this.loadLimit,
      tags: this.tagsToFilter
    };
  }

  private _query() {
    this.agentsRef.$query(this._getQueryPayload(this.services))
      .then(() => {
        this.infiniteScroll.reload();
      })
      .catch((error) => {
        this.$log.debug('Fail to $query', error);
      })
  }
}

angular
  .module('bringoz.admin.deliveries')
  .component(
    'servicesAssignAgentDialogView', {
      bindings: {
        serviceIds: '<',
        routeIds: '<?',
        highPriorityAgentsIds: '<?',
        linkedAgentId: '<?',
        isIgnoreScore: '<?',
        isShowAllToggleVisible: '<?',
        isAssociateMode: '<?',
        onToggleIsIgnoreScore: '&',
        onAssign: '&',
      },
      template: require('./services-assign-agent-dialog-view.html').default,
      controller: ServicesAssignAgentDialogViewCtrl
    }
  );
